import productStatus from './productStatus'
import changeIsFlow from './changeIsFlow'

export default [productStatus, changeIsFlow]
